import React, { FC } from "react";

interface SectionHeadingProps {
  colorVariant: "white" | "primary";
  title: string;
}

export const SectionHeading: FC<SectionHeadingProps> = ({
  title,
  colorVariant,
}) => {
  const isDotVisible = false;
  const textColor = colorVariant === "white" ? "text-white" : "text-primary";
  const dotColor = colorVariant === "white" ? "bg-white" : "bg-primaryBlue";

  return (
    <div className="flex mb-9">
      {isDotVisible && <div className={`size-3 rounded-full mr-3 mt-1 ${dotColor}`} />}
      <h2 className={`text-sm md:text-md font-medium ${textColor}`}>{title}</h2>
    </div>
  );
};
